// The account portal (or an appliance licence) supplies the feature list.
// Show paid configuration only after that list has been verified. Branding
// can be purchased separately, so it must not depend on the Business tier name.
export function hasEntitledFeature(entitlement, feature) {
  return Boolean(entitlement?.available && Array.isArray(entitlement.features) &&
    entitlement.features.includes(feature));
}
